<template>
    <div id="grabOrders">
        <custom-table ref="customTable" has-organization="true" :customOptions="customOptions" :columns="columns"
            :add-text="btnPreFn('hitchRideAutoAccept_addLine', false) ? '添加线路' : ''" @addFn="addLine" :add-texts="btnPreFn('hitchRideAutoAccept_driver', false) ? '转单配置' : ''" :addTextsType="null" @addFns="addConfig">
            <template slot="search-bottom">
                <div class="blueInfo">* 配置抢单策略后，该线路来单后将按照抢单司机顺序自动抢单</div>
            </template>

            <template slot="table-operation">
                <el-table-column label="操作" fixed="right" width="128px">
                    <div slot-scope="{row}" class="custom-action">
                        <el-button type="text" @click="editRow(row)">编辑</el-button>
                        <el-button type="text" style="color: red;" @click="delRow(row)">删除</el-button>
                    </div>
                </el-table-column>
            </template>
            <template slot-scope="{item, row}">
                <template v-if="['updated', 'created'].includes(item.prop)">{{ row[item.prop] | filterTime }}</template>
                <template v-else-if="item.prop === 'lineName'">{{ row.startCity }} - {{ row.endCity }}</template>
                <template v-else-if="item.prop === 'config'">
                    <span v-if="row.driverId">已配置</span>
                    <span v-else style="color: #AAA">未配置</span>
                </template>
                <template v-else-if="item.prop === 'status'">
                    <el-switch v-model="row.status" :active-value="1" :inactive-value="2"
                        @change="switchChange($event, row)"></el-switch>
                </template>
                <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
            </template>
        </custom-table>
        <!-- 添加线路 -->
        <el-dialog title="添加线路" :visible.sync="lineVisible" width="500px" :close-on-click-modal="false"
            :before-close="lineClose">
            <div class="blueInfo">注意：同一条线路仅支持1个机构运营</div>

            <el-form :model="lineForm" :rules="lineRules" ref="lineForm" label-width="100px">
                <el-form-item label="出发城市" prop="startCityCode">
                    <el-select v-model="lineForm.startCityCode" placeholder="请选择出发城市" filterable>
                        <el-option v-for="item in cityList" :key="item.id" :value="item.gaodeCityCode"
                            :label="item.cityName"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="目的城市" prop="endCityCode">
                    <el-select v-model="lineForm.endCityCode" placeholder="请选择目的城市" filterable>
                        <el-option v-for="item in allCityList" :key="item.value" :value="item.value"
                            :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="机构名称" prop="organizationId">
                    <el-select v-model="lineForm.organizationId" placeholder="请选择机构名称">
                        <el-option v-for="item in organizations" :key="item.id" :value="item.id"
                            :label="item.name"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div slot="footer">
                <el-button @click="lineClose">取 消</el-button>
                <el-button type="primary" @click="saveLine">确 认</el-button>
            </div>
        </el-dialog>
        <!-- 转单配置 -->
        <el-dialog title="转单配置" :visible.sync="configVisible" width="800px" :close-on-click-modal="false">
            <div class="formTitle">权限管理</div>
            <div class="blueInfo">注意：以下司机可使用司机端的「订单转让」功能。抢单策略中配置的抢单司机默认会加入该列表</div>

            <custom-table ref="driverTable" has-organization="true" :customOptions="driverOptions" :maxHeight="400"
                :refreshShow="false" :paging="false" :columns="driverColumns">

                <template slot="table-operation">
                    <el-table-column label="操作" fixed="right" width="80px">
                        <div slot-scope="{row}" class="custom-action">
                            <el-button type="text" style="color: red;" @click="delDriverRow(row)">移除</el-button>
                        </div>
                    </el-table-column>
                </template>
                <template slot-scope="{item, row}">
                    <template>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
                </template>
            </custom-table>

            <el-button size="large" style="width: 100%;" @click="addDriver">添加司机</el-button>
        </el-dialog>
        <!-- 添加司机 -->
        <el-dialog title="添加司机" :visible.sync="driverVisible" width="800px" :close-on-click-modal="false" :before-close="driverClose">
            <div class="blueInfo">注意：请输入任一司机信息，搜索司机后再添加</div>

            <el-form :model="driverForm" :rules="driverRules" ref="driverForm" label-width="100px">
                <el-form-item label="司机姓名" prop="driverId">
                    <el-select v-model="driverForm.driverId" placeholder="输入司机姓名/电话搜索" filterable remote reserve-keyword
                        :remote-method="getDriverList" :loading="loading">
                        <el-option v-for="item in driverList" :key="item.driverId" :value="item.driverId"
                            :label="item.driverName + '   ' + item.driverPhone" :disabled="!item.licenseNo"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>

            <div slot="footer">
                <el-button @click="driverClose">取 消</el-button>
                <el-button type="primary" @click="saveDriver">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 编辑抢单策略 -->
        <el-dialog title="编辑抢单策略" v-if="editVisible" :visible.sync="editVisible" width="600px" :before-close="editClose"
            :close-on-click-modal="false">
            <div class="blueInfo">注意：线路有乘客发单时，我们将按以下策略执行自动抢单</div>

            <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="100px">
                <div class="formTitle">价格策略</div>
                <el-form-item label="订单价格" prop="minAmount">
                    <div class="flex">
                        <el-input v-model="editForm.minAmount" placeholder="输入0则不限制"
                            v-input-filter="{ min: 0, max: 1000, precision: 0 }">
                            <template slot="append">元</template>
                        </el-input>
                        <span style="width: 120px; text-align: center;">以上的订单</span>
                    </div>
                </el-form-item>
                <el-form-item label="里程单价" prop="minAmountDistance">
                    <div class="flex">
                        <el-input v-model="editForm.minAmountDistance" placeholder="输入0则不限制"
                            v-input-filter="{ min: 0, max: 10, precision: 2 }">
                            <template slot="append">元/公里</template>
                        </el-input>
                        <span style="width: 120px; text-align: center;">以上的订单</span>
                    </div>
                </el-form-item>
                <div class="formTitle">里程策略</div>
                <el-form-item label="订单里程" prop="minDistance">
                    <div class="flex">
                        <el-input v-model="editForm.minDistance" placeholder="输入0则不限制"
                            v-input-filter="{ min: 0, max: 2000, precision: 0 }">
                            <template slot="append">公里</template>
                        </el-input>
                        <span style="width: 120px; text-align: center;">以上的订单</span>
                    </div>
                </el-form-item>
                <div class="formTitle">其他策略</div>
                <el-form-item label="出发时间" required>
                    <div class="flex mb0">
                        <el-form-item prop="startDepartureTime">
                            <el-select v-model="editForm.startDepartureTime">
                                <el-option v-for="item in hours" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <span style="width: 40px;text-align: center;">至</span>
                        <el-form-item prop="endDepartureTime">
                            <el-select v-model="editForm.endDepartureTime">
                                <el-option v-for="item in hours" :key="item.value" :label="item.label"
                                    :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <span style="width: 120px;text-align: center;">以内的订单</span>
                    </div>
                </el-form-item>
                <el-form-item label="抢单延时" required>
                    <div class="flex mb0">
                        <el-form-item prop="startAutoTime">
                            <el-input v-model="editForm.startAutoTime" placeholder=""
                                v-input-filter="{ min: 5, max: 10, precision: 0 }">
                                <template slot="append">秒</template>
                            </el-input>
                        </el-form-item>
                        <span style="width: 40px;text-align: center;">至</span>
                        <el-form-item prop="endAutoTime">
                            <el-input v-model="editForm.endAutoTime" placeholder=""
                                v-input-filter="{ min: 20, max: 60, precision: 0 }">
                                <template slot="append">秒</template>
                            </el-input>
                        </el-form-item>
                        <span style="width: 140px;text-align: center;">内自动抢单</span>
                    </div>
                </el-form-item>
                <div class="formTitle">抢单司机</div>
                <div class="blueInfo">注意：当前线路有新订单时，将使用以下司机信息自动抢单，该司机可在司机端转单给其他司机</div>
                <el-form-item label="抢单司机" prop="driverId">
                    <el-select v-model="editForm.driverId" placeholder="输入司机姓名搜索" filterable remote reserve-keyword
                        :remote-method="getDriverListO" :loading="loading">
                        <el-option v-for="item in driverList" :key="item.driverId" :value="item.driverId"
                            :label="item.driverName + '   ' + item.driverPhone + '  ' + (item.licenseNo ? item.licenseNo : '暂未绑定车辆')" :disabled="!item.licenseNo"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>

            <div slot="footer">
                <el-button @click="editClose">取 消</el-button>
                <el-button type="primary" @click="saveEdit">保 存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { cityCodeJson } from "@/assets/js/city";
export default {
    name: "grabOrders",
    components: {
    },
    data() {
        let arr = [];
        cityCodeJson.forEach((pre) => {
            if (pre.districts) {
                arr.push(...pre.districts);
            }
        });
        arr.forEach((item) => {
            item.label = item.name;
            item.value = item.citycode;
        });
        // 生成24小时的下拉框数据
        let hours = [];
        for (let i = 0; i <= 24; i++) {
            hours.push({
                label: i < 10 ? "0" + i + ":00" : i + ":00",
                value: i,
            });
        }
        return {
            hours: hours,
            // 配置项
            customOptions: {
                // 请求的列表url
                url: '/api/v1/manage/hitchRide/autoAcceptRule',
                params: {
                    page: 1, // 页数
                    size: 20 // 每页条数
                },
                search: [
                    {
                        type: 'select', field: 'startCityCode', name: '出发城市', value: '', option: [],
                        clearable: true,
                        filterable: true,
                    },
                    {
                        type: "select",
                        field: "endCityCode",
                        name: "目的城市",
                        value: "",
                        option: arr,
                        clearable: true,
                        filterable: true,
                    },
                    { type: 'select', field: 'status', name: '线路状态', value: '', option: this.$const.LINESTATUS, clearable: true }
                ]
            },
            // 表头
            columns: [
                { prop: 'lineName', label: '线路名称' },
                { prop: 'config', label: '抢单策略' },
                { prop: 'driverName', label: '抢单司机' },
                { prop: 'status', label: '状态' },
                { prop: 'created', label: '创建时间' },
                { prop: 'updated', label: '更新时间' },
            ],

            // 添加线路弹窗
            lineVisible: false,
            allCityList: arr,
            lineForm: {
                startCityCode: null,
                endCityCode: null,
                organizationId: null
            },
            lineRules: {
                startCityCode: [
                    { required: true, message: '请选择出发城市', trigger: 'change' }
                ],
                endCityCode: [
                    { required: true, message: '请选择目的城市', trigger: 'change' }
                ],
                organizationId: [
                    { required: true, message: '请选择机构名称', trigger: 'change' }
                ]
            },

            configVisible: false,
            driverOptions: {
                // 请求的列表url
                url: '/api/v1/manage/hitchRide/driverTransfer',
                params: {},
                search: []
            },
            driverColumns: [
                { prop: 'channelName', label: '所属渠道' },
                { prop: 'driverName', label: '司机姓名' },
                { prop: 'licenseNo', label: '车辆号牌' },
            ],
            driverVisible: false,
            driverForm: {
                driverId: ""
            },
            driverRules: {
                driverId: [{ required: true, message: '请选择司机', trigger: 'blur' }]
            },

            editVisible: false,
            editForm: {
                minAmount: null,
                minAmountDistance: null,
                minDistance: null,
                startDepartureTime: 0,
                endDepartureTime: 24,
                startAutoTime: 10,
                endAutoTime: 20,
                driverId: null,
            },
            editRules: {
                minAmount: [{ required: true, message: '请输入最近订单价格' }],
                minAmountDistance: [{ required: true, message: '请输入最低里程单价' }],
                minDistance: [{ required: true, message: '请输入最低订单里程' }],
                startDepartureTime: [{ required: true, message: '请输入出发时间' }],
                endDepartureTime: [{ required: true, message: '请输入出发时间' }],
                startAutoTime: [{ required: true, message: '请输入抢单延时' }],
                endAutoTime: [{ required: true, message: '请输入抢单延时' }],
                driverId: [{ required: true, message: '请选择抢单司机' }],
            },
            rowOrganizationId: null,
            driverList: [],
            loading: false

        }
    },
    computed: {
        ...mapGetters({
            cityList: "cityListGetter",
        }),
    },
    async created() {
        await this.mixinOrganizations();
        if(this.customOptions.search[0].field == 'organizationId'){
            this.customOptions.search[1].option = this.cityList
        }else {
            this.customOptions.search[0].option = this.cityList
        }
        
    },
    methods: {
        getDriverList(query){
            this.getDriver(query)
        },
        getDriverListO(query){
            this.getDriver(query, this.rowOrganizationId)
        },
        async getDriver(query, organizationId) {
            if (query) {
                this.loading = true;
                let url = "/api/v1/manage/hitchRide/driverTransfer/driver";
                let { code, data } = await this.$axios.get(url, {
                    keyWords: query,
                    organizationId: organizationId || null
                });
                if (code == 1) {
                    this.driverList = data;
                }
                this.loading = false;
            } else {
                this.options = [];
            }
        },
        // 添加线路
        addLine() {
            this.lineVisible = true;
        },
        lineClose() {
            this.$refs.lineForm.resetFields()
            this.lineVisible = false;
        },
        // 保存线路
        saveLine() {
            this.$refs.lineForm.validate(async (valid) => {
                if (valid) {
                    let url = '/api/v1/manage/hitchRide/autoAcceptRule';
                    let { code, data } = await this.$axios.post(url, {
                        ...this.lineForm,
                        startCity: this.$utils.getCityName(this.allCityList, this.lineForm.startCityCode),
                        endCity: this.$utils.getCityName(this.allCityList, this.lineForm.endCityCode),
                    });
                    if (code == 1) {
                        this.$message.success('抢单线路已添加')
                        this.$refs.customTable.listFn()
                        this.lineClose()
                    }
                }
            });
        },
        // 转单配置
        addConfig() {
            this.configVisible = true
            this.$nextTick(() => {
                this.$refs.driverTable.listFn()
            })
        },
        delDriverRow(row) {
            this.$confirm('是否确认移除当前转单司机？', '移除转单司机', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let url = "/api/v1/manage/hitchRide/driverTransfer";
                let { code } = await this.$axios.delete(url, {
                    id: row.id
                });
                if (code === 1) {
                    this.$message.success('转单司机已移除');
                    this.$refs.driverTable.listFn()
                }
            }).catch(() => { });
        },
        addDriver() {
            this.driverVisible = true
            this.driverList = []
        },
        driverClose() {
            this.driverVisible = false
            this.$refs.driverForm.resetFields()
        },
        saveDriver() {
            this.$refs.driverForm.validate(async valid => {
                if (valid) {
                    let url = "/api/v1/manage/hitchRide/driverTransfer";
                    let {code} = await this.$axios.post(url, this.driverForm);
                    if(code === 1) {
                        this.$message.success('添加成功');
                        this.driverClose()
                        this.$refs.driverTable.listFn()
                    }
                }
            })
        },
        switchChange(val, row) {
            let status = val == 1 ? '开启' : '关闭';
            let title = `${status}抢单策略`;
            let content = `是否确认${status}当前线路抢单策略？`
            console.log(val, row)
            this.$confirm(content, title, {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                if (val == 1 && !row.driverId) {
                    this.$message.error('请配置抢单策略后再启用');
                    row.status = val == 1 ? 2 : 1;
                    return
                }
                let url = '/api/v1/manage/hitchRide/autoAcceptRule/status'
                let { code, data } = await this.$axios.put(url, { id: row.id, status: val });
                if (code === 1) {
                    this.$message.success(`抢单策略已${status}`);
                    this.$refs.customTable.listFn()
                }
            }).catch(() => {
                row.status = val == 1 ? 2 : 1
            });
        },
        editRow(row) {
            this.driverList = []
            this.rowOrganizationId = row.organizationId;
            this.getDriverListO(row.driverName, row.organizationId);
            this.editForm = {
                id: row.id,
                minAmount: row.minAmount,
                minAmountDistance: row.minAmountDistance,
                minDistance: row.minDistance,
                startDepartureTime: row.startDepartureTime || 0,
                endDepartureTime: row.endDepartureTime || 24,
                startAutoTime: row.startAutoTime || 10,
                endAutoTime: row.endAutoTime || 20,
                driverId: row.driverId,
            }
            this.editVisible = true;
        },
        delRow(row) {
            this.$confirm('是否确认删除当前线路抢单策略？', '删除抢单策略', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let url = '/api/v1/manage/hitchRide/autoAcceptRule';
                let { code } = await this.$axios.delete(url, { id: row.id })
                if (code === 1) {
                    this.$message.success('抢单策略已删除');
                    this.$refs.customTable.listFn();
                }
            }).catch(() => { });
        },
        editClose() {
            this.editVisible = false;
            this.$refs.editForm.resetFields();
        },

        saveEdit() {
            this.$refs.editForm.validate(async (valid) => {
                if (valid) {
                    console.log('valid::: ', this.editForm);
                    let url = "/api/v1/manage/hitchRide/autoAcceptRule";
                    let { code } = await this.$axios.put(url, this.editForm);
                    if (code === 1) {
                        this.$message.success("抢单策略配置成功");
                        this.editClose();
                        this.$refs.customTable.listFn();
                    }
                }
            });
        },
    }
}
</script>

<style lang="less">
.mb0 .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 0;
}
</style>
